export default {
    namespaced: true,
    state: {
        obj: {},
        objs: [],
        default_days: [
            { key: 1, value: 'Minggu' },
            { key: 2, value: 'Senin' },
            { key: 3, value: 'Selasa' },
            { key: 4, value: 'Rabu' },
            { key: 5, value: 'Kamis' },
            { key: 6, value: 'Jumat' },
            { key: 7, value: 'Sabtu' },
        ],
    },
    mutations: {
        setObjs(state, pload) {
            state.objs = pload
        },
        setObj(state, pload) {
            state.obj = pload
        },
    },
    actions: {
        getObj({rootState, commit}, outlet_code) {
            return new Promise((resolve, reject) => {
                let url = `${rootState.config.apiHost}outlets/${outlet_code}`
                this._vm.$axios.get(url, { headers: { 'Authorization': 'Bearer ' + rootState.token, 'Content-Type': 'application/json' } })
                    .then(response => {
                        commit('setObj', response.data.data)
                        resolve(response.data.data)
                    }, error => {
                        reject(error)
                    })
            })
        },
        getObjs({rootState, commit}, params = {}) {
            return new Promise((resolve, reject) => {
                let url = rootState.config.apiHost + "outlets"
                this._vm.$axios.get(url, {
                    params: params,
                    headers:{'Authorization': 'Bearer '+ rootState.token, 'Content-Type': 'application/json'}
                })
                    .then(response => {
                        commit('setObjs', response.data.data)
                        resolve(response)
                    }, error => {
                        reject(error)
                    })
            })
        },
        postObj({rootState}, payload) {
            return new Promise((resolve, reject) => {
                let url = rootState.config.apiHost + "outlets"
                this._vm.$axios.post(url, JSON.stringify(payload), {headers:{'Authorization': 'Bearer '+ rootState.token, 'Content-Type': 'application/json'}})
                    .then(response => {
                        resolve(response)
                    }, error => {
                        reject(error)
                    })
            })
        },
        putObj({rootState}, {payload, outlet_code}){
            return new Promise((resolve, reject) => {
                let url = rootState.config.apiHost + 'outlets/' + outlet_code
                this._vm.$axios.put(url, JSON.stringify(payload), {headers:{'Authorization': 'Bearer '+ rootState.token, 'Content-Type': 'application/json'}})
                .then (response => {
                    resolve(response)
                }, error => {
                    reject(error)
                })
            })
        },
        deleteObj({rootState}, outlet_code){
            return new Promise((resolve, reject) => {
                let url = rootState.config.apiHost + "outlets/" + outlet_code
                this._vm.$axios.delete(url, {headers:{'Authorization': 'Bearer '+ rootState.token, 'Content-Type': 'application/json'}})
                    .then((response) => {
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error('API Error:', error);
                        reject(error);
                    });
            })
        },
        updateStatus({rootState}, {outlet_code, payload}) {
            return new Promise((resolve, reject) => {
                let url = `${rootState.config.apiHost}outlets/${outlet_code}/update-status`;
                this._vm.$axios.post(url, JSON.stringify(payload), {headers:{'Authorization': 'Bearer '+ rootState.token, 'Content-Type': 'application/json'}})
                .then (response => {
                    resolve(response)
                }, error => {
                    reject(error)
                })
            })
        }
    }
}